import { MARKETING_API_URL } from '../shared/constants';
import { Api } from '../shared/api';
import { select } from '../shared/utils/dom';

// API instance set to the Marketing API host
export default new Api(MARKETING_API_URL);

export function showError(messageKey, message, title = 'Error') {
  const container = select('#page-alerts');
  if (!container) {
    console.log('API error can not be shown because no element exists that matches the selector #page-alerts.');
  }

  const html = `
      <div id="alert-${messageKey}" class="alert alert--error" id="js-online-features-unavailable" tabindex="-1" role="alert">
        <svg aria-hidden="true" class="icon icon-error " role="img">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-error"></use>
        </svg>
        <p><strong>${title}</strong>
        <br>
        ${message}
        </p>
      </div>
    `;
  container.insertAdjacentHTML('afterbegin', html);
  const notification = select('#js-online-features-unavailable');
  if (notification) {
    notification.focus();
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/marketing/api.js